import type React from "react";

import { AddCircleOutline, CheckCircle } from "@material-ui/icons";

const styles = { height: "24px", width: "24px", marginLeft: "auto" };

interface Props {
  checked: boolean;
}

export const AddIcon: React.VFC<Props> = ({ checked }) => {
  return checked ? <CheckCircle style={styles} /> : <AddCircleOutline style={styles} />;
};
